import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, withLatestFrom } from 'rxjs/operators';

import { addDevice } from './device.actions';
import { addSystemIdentificationParameters } from './system-identification-parameter.actions';
import {
  allSystemIdentificationParameters,
  SystemIdentificationParameter,
  systemIdentificationParameterId,
} from './system-identification-parameter.model';
import { createSystemIdentificationParameterByIdSelector } from './system-identification-parameter.selectors';

import { AppState } from './index';

@Injectable()
export class SystemIdentificationParameterEffects {
  private actions$ = inject(Actions);
  private store$ = inject<Store<AppState>>(Store);

  addSystemIdentificationParametersOnAddDevice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addDevice),
      withLatestFrom(this.store$),
      map(([action, state]) => {
        const device = action.device;
        const systemIdentificationParameters: SystemIdentificationParameter[] = [];

        allSystemIdentificationParameters.map((systemIdentificationParameter) => {
          const deviceSystemIdentificationParameter = createSystemIdentificationParameterByIdSelector(
            systemIdentificationParameterId(systemIdentificationParameter, device),
          ).projector(state.systemIdentificationParameters.entities);

          if (!deviceSystemIdentificationParameter) {
            systemIdentificationParameters.push({
              ...systemIdentificationParameter,
              deviceSerialNumber: device.serialNumber,
              id: systemIdentificationParameterId(systemIdentificationParameter, device),
            } as SystemIdentificationParameter);
          }
        });

        return addSystemIdentificationParameters({ systemIdentificationParameters });
      }),
    ),
  );
}
